import React, { useEffect, useRef, useState } from "react";
import RatingModal from "../RatingModal";
import axios from "axios";
import { Toaster } from "components/ui_components/Toaster";
import { useTranslation } from "react-i18next";

import RatingDiamonds from "components/ui_components/ratingDiamonds";
import { useGlobalState } from "context/GlobalStateContext";
import { useRouter } from "next/router";
import AuthentificationModal from "../(storeInfo)/AuthetificationModal";
function RateStore({
  generalReview,
  setGeneralReview,
  clientServiceReview,
  setClientServiceReview,
  productReview,
  setProductReview,
  storeId,
  redirectSignin,
  refetchStoreReviews,
}) {
  const moddalRef = useRef<HTMLDialogElement>(null);
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const [showToaster, setShowToaster] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const { isLoggedIn } = useGlobalState();
  const [openAuthModal, setOpenAuthModal] = useState(false);

  const [globalReviewStatus, setGlobalReviewStatus] = useState<{
    label: string;
    success: boolean;
  } | null>(null);

  const { t: translate } = useTranslation("page_detail");

  function openModal() {
    setModalIsOpen(true);
    moddalRef.current?.showModal();
  }
  function closeModal() {
    setModalIsOpen(false);
    moddalRef.current?.close();
  }

  //  to send rating when redirect back from login

  useEffect(() => {
    if (isLoggedIn) {
      const pendingRating = localStorage.getItem("pendingRating");
      if (pendingRating) {
        try {
          const ratingData = JSON.parse(pendingRating);
          openModal();

          //  general review value
          setGeneralReview(ratingData?.general_review || null);

          // send automatically when general review exist
          if (ratingData?.general_review) {
            sendReview({
              general_review: ratingData.general_review,
            });
          }
        } catch (error) {
          console.error("Error parsing pending rating", error);
          localStorage.removeItem("pendingRating");
        }
      }
    }
  }, [isLoggedIn]);

  const requestLogin = ({ general_review }: { general_review?: number }) => {
    if (!isLoggedIn) {
      const pendingRating = {
        general_review: general_review ?? generalReview,
      };

      localStorage.setItem("pendingRating", JSON.stringify(pendingRating));
      setOpenAuthModal(true);
    } else {
      sendReview({ general_review: general_review ?? generalReview });
    }
  };

  function sendReview(
    payload: Partial<{
      general_review: number;
      customer_service_review: number;
      product_image_review: number;
    }>,
  ) {
    axios
      .post(
        `${process.env.NEXT_PUBLIC_API_BASE_URL}/reviews`,
        {
          store_id: storeId && storeId !== 0 ? storeId : Number(localStorage?.getItem("storeId")),
          general_review: generalReview,
          customer_service_review: clientServiceReview,
          product_image_review: productReview,
          ...payload,
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        },
      )
      .then(() => {
        setGlobalReviewStatus({ label: "globalReviewSuccess", success: true });
        localStorage.removeItem("pendingRating");

        refetchStoreReviews();
      })
      .catch((error) => {
        console.error(error);
        setGlobalReviewStatus({ label: "globalReviewFailure", success: false });
      });
    openModal();
  }

  useEffect(() => {
    if (generalReview !== 0 && clientServiceReview === 0 && productReview === 0) {
      setHasSubmitted(false);
    }
  }, [generalReview, clientServiceReview, productReview]);

  useEffect(() => {
    if (
      generalReview !== 0 &&
      clientServiceReview !== 0 &&
      productReview !== 0 &&
      globalReviewStatus
    ) {
      setShowToaster(true);
    }
  }, [generalReview, clientServiceReview, productReview, globalReviewStatus]);

  return (
    <div className=" flex gap-0 mt-2 mb-5">
      <RatingDiamonds
        id="general"
        value={generalReview}
        onChange={(val) => {
          setGeneralReview(val);
          requestLogin({ general_review: val });
        }}
      />

      {modalIsOpen && (
        <RatingModal
          modalRef={moddalRef}
          closeModal={closeModal}
          clientServiceReview={clientServiceReview}
          setClientServiceReview={setClientServiceReview}
          productReview={productReview}
          setProductReview={setProductReview}
          sendReview={requestLogin}
          setHasSubmitted={setHasSubmitted}
        />
      )}
      {showToaster && globalReviewStatus && hasSubmitted && (
        <Toaster
          key={0}
          index={0}
          message={translate(globalReviewStatus.label)}
          type={globalReviewStatus.success ? "success" : "error"}
          onClose={() => setShowToaster(false)}
        />
      )}
      <AuthentificationModal
        isOpen={openAuthModal}
        onClose={() => setOpenAuthModal(false)}
        onConnect={redirectSignin}
      />
    </div>
  );
}

export default RateStore;
